import React, {useEffect, useRef, useState} from 'react';
import {Redirect} from 'react-router';
import axios from 'axios';
import moment from 'moment-timezone';

import Auxi from '../../hoc/Auxi';
import AppLayout from '../../containers/Layout/AppLayout';
import Avatar from '../../assets/images/user/message-avatar.png';

import Toast from '../../components/Widgets/CustomToast';
import Spinner from '../../components/Widgets/Spinner';
import Websocket from 'react-websocket';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentDots } from '@fortawesome/free-solid-svg-icons';

import '../../assets/css/style.css';
import VoiceMail from '../../assets/images/VISUAL-VOICEMAIL_WHITE.PNG';
import IotumVideoConference from '../../assets/images/VIP-MEETINGS_WHITE.png';
import Textable from '../../assets/images/VIP-GROUP-MESSAGING_WHITE.png';
import Settings from '../../assets/images/SETTINGS_WHITE.PNG';
import MoveCall from '../../assets/images/MOVE-CALL_WHITE.png';
import CallParking from '../../assets/images/CALL_PARKING.png';
import CallHistory from '../../assets/images/WhiteCallHistoryIcon.png';

import VoiceMailBlack from '../../assets/images/BlackVisVMIcon.png';
import IotumVideoConferenceBlack from '../../assets/images/VIP-MEETINGS_BLACK.png';
import TextableBlack from '../../assets/images/VIP-GROUP-MESSAGING_BLACK.png';
import SettingsBlack from '../../assets/images/BlackSettingsIcon.png';
import MoveCallBlack from '../../assets/images/BlackMoveCallIcon.png';
import CallParkingBlack from '../../assets/images/BlackCallParkIcon.png';
import CallHistoryBlack from '../../assets/images/BlackCallHistoryIcon.png';

import VoiceMailBlue from '../../assets/images/DrkBlueVisVMIcon.png';
import SettingsBlue from '../../assets/images/DrkBlueSettingsIcon.png';
import MoveCallBlue from '../../assets/images/DrkBlueMoveCallIcon.png';
import CallParkingBlue from '../../assets/images/DrkBlueCallParkIcon.png';
import IotumVideoConferenceBlue from '../../assets/images/DrkBlueVIPMeetings.png';
import TextableBlue from '../../assets/images/DrkBlueTextable.png';
import CallHistoryBlue from '../../assets/images/DrkBlueCallHistoryIcon.png';
import MfaAuthModal from '../../components/Widgets/MfaAuthModal';

import { ThemeProvider } from 'react-bootstrap';

const Index = (props) => {

    const [openVoicemail, setOpenVoicemail] = useState(false);
    const [openSettings, setOpenSettings] = useState(false);
    const [openViodeConf, setOpenVideoConf] = useState(false);
    const [openCallParking, setOpenCallParking] = useState(false);
    const [openTextable, setOpenTextable] = useState(false);
    const [openCallHistory, setOpenCallHistory] = useState(false);
    const [redirect, setRedirect] = useState(null);
    const [cloudId, setCloudId] = useState(null);
    const [icons, setIcons] = useState("white");
    const [textable, setTextable] = useState(false)
    const [callHistory, setCallHistory] = useState(false)
    const [textableName, setTextableName] = useState("")
    const [textableUrl, setTextableUrl] = useState("")
    const [textableProviderId, setTextableProviderId] = useState("")
    const [jwtToken, setJWTToken] = useState("")
    const [iotumUrl, setIotumUrl] = useState(false)
    const [iotumName, setIotumName] = useState("")
    const [backgroundImage, setBackGroundImage] = useState(localStorage.getItem("custom_tab_background"));
    const mfaAuthRef = useRef(null);

    let url = decodeURIComponent(window.location.href)

    url = url.substring(
        url.lastIndexOf("?username="),
            url.length
    );

    useEffect(() => {

        var url = new URL(window.location.href);
        let myCloudId = url.searchParams.get("cloud_id")
        myCloudId = myCloudId.replaceAll("*","");
        setCloudId(myCloudId);
        let username = url.searchParams.get('username');
        let password = url.searchParams.get('password');
        loginAndGetDomain(username, password, myCloudId);
        // on signin always get logos
        const payLoad = {
            base_url: window.location.origin,
        };
        axios.post(`${process.env.REACT_APP_SIMPLE_API_URL}getWhiteLabelOptions`, payLoad)
        .then(response => {
            localStorage.setItem("signin_logo",response.data.signin_logo);
            localStorage.setItem("dashboard_logo",response.data.dashboard_logo);
            localStorage.setItem("custom_tab_background",response.data.custom_tab_background);
            
            // Check if call_history is false, then call domain-level permissions API
            if (response.data.call_history === false) {
                // Extract domain from username
                const urlParams = new URL(window.location.href);
                const username = urlParams.searchParams.get('username');
                const domain = username ? username.split('@')[1] : null;
                
                if (domain && myCloudId) {
                    const domainPayload = {
                        cloud_id: myCloudId,
                        domain: domain
                    };
                    
                    axios.post(`${process.env.REACT_APP_SIMPLE_API_URL}getDomainLevelMessagePermissions`, domainPayload)
                        .then(domainResponse => {
                            setCallHistory(domainResponse.data.call_history);
                        })
                        .catch(domainErr => {
                            console.log("Error fetching domain-level permissions:", domainErr);
                            setCallHistory(response.data.call_history);
                        });
                } else {
                    setCallHistory(response.data.call_history);
                }
            } else {
                setCallHistory(response.data.call_history);
            }
            
            setBackGroundImage(response.data.custom_tab_background);
            setIcons(response.data.icons);
        }).catch(err => {
            console.log(err.response.data);
        });
        
    
    }, []);

    const loginAndGetDomain = (username, password, cloudId) => {
        const payLoad = {
            user: username,
            password: password,
            cloud_id: cloudId
        }
        axios.post(`${process.env.REACT_APP_API_URL}/signin`, payLoad)
        .then(async (response) => {
            const afterSigninSuccess = () => {
                localStorage.setItem("access_token", response.data.access_token);
                checkTextable(response.data.user, response.data.domain, cloudId, password);
                getItotumDetails(response.data.domain, cloudId, response.data.user);
            };

            if (response.data.sso === "sso_required") {
                const completed = await mfaAuthRef.current?.openAndAuthenticate({
                    authType: 'sso',
                    scope: response.data.scope,
                    cloudId: cloudId
                });
                if (!completed) return;
                response = await axios.post(`${process.env.REACT_APP_API_URL}/signin`, payLoad);
            }

            if (response.data.mfa === "mfa_required") {
                const authenticated = await mfaAuthRef.current?.openAndAuthenticate({
                    username: response.data.username || `${response.data.user}@${response.data.domain}`,
                    cloudId: cloudId,
                    password: password,
                    mfaType: response.data.mfa_type,
                    mfaVendor: response.data.mfa_vendor,
                    accessToken: response.data.access_token
                });
                if (!authenticated) return;
            }

            afterSigninSuccess();
        }).catch(err => {
            console.log(err.response.data);
        });
    }

    const checkTextable = (user, domain, cloudId, password) => {
        const payLoad = {
            user: user,
            domain: domain,
            cloud_id: cloudId,
            password: password
        }
        axios.post(`${process.env.REACT_APP_SIMPLE_API_URL}checkTextable`, payLoad)
        .then(response => {
            setTextable(true)
            setTextableName(response.data.textable_name)
            setTextableUrl(response.data.textable_url)
            setTextableProviderId(response.data.textable_provider_id)
            setJWTToken(response.data.jwt)
        }).catch(err => {
            setTextable(false)
        });
    }
    const fullyEncode =(str) => {
        return encodeURIComponent(str).replace(/[!'()*]/g, (char) =>
            `%${char.charCodeAt(0).toString(16).toUpperCase()}`
        );
    }
    const getItotumDetails = (domain, cloudId, user) => {
        const payLoad = {
            user: user,
            domain: domain,
            cloud_id: cloudId
        }
        axios.post(`${process.env.REACT_APP_SIMPLE_API_URL}getIotumUrl`, payLoad)
        .then(response => {
            setIotumUrl(response.data.iotum_url)
            setIotumName(response.data.iotum_name)
        }).catch(err => {
            setIotumUrl("")
        });
    }
    
    const voiceMailPath = "/voice_messages" + url;
    const newMessagingPath = "/messages" + url +"&from_index=true";
    const vmailSettingsPath = "/vmail_settings" + url;
    const callParkingPath = "/call_parkings" + url;
    const crexendoHDPath = "/snap_hd" + url;
    const textablePath = "/textable" + url;
    const callHistoryPath = "/call_logs" + url;

    const videoConferenceHandler = (myIotumUrl) => {
        // let iotumURL = "https://iotum.callbridge.rocks/auth?host_id=64440&login_token_public_key=39abd592be30daf3245eaf5f6d3f75b17e90ba5db1e86ac38f606bceec6f2ce1&"
        // iotumURL += "cxdo_redirect_url="+window.location.href
        // iotumURL += "&redirect_url=/conf/conferences/create?events=true";
        //https://ocisaevolgo.meetings.crexendovip.com/auth?host_id=4921512&login_token_public_key=d610e28e098af13d615acbe8c4836063009357ce57c19ca47fba2aec72a6d56b&redirect_url=%2Fconf%2Fconferences%2Fcreate%3Fevents%3Dtrue%26return_url%3Dhttps%253A%252F%252Fcxdo-web-dev.saevolgo.com%252Findex%253Fusername%253D120%2540OCISaevolgo%2526password%253DQ3JleGVuZG8yMDI1%2526cloud_id%253DCREXDEMODEV
        let redirectUrl = fullyEncode(window.location.href);
        redirectUrl = fullyEncode(redirectUrl);
       // https://OCISaevolgo.meetings.crexendovip.com/auth?host_id=4921512&login_token_public_key=d610e28e098af13d615acbe8c4836063009357ce57c19ca47fba2aec72a6d56b&redirect_url=%2Fconf%2Fconferences%2Fcreate%3Fevents%3Dtrue%26return_url%3Dhttp%3A%2F%2Flocalhost%3A3000%2Findex%3Fusername%3D120%40OCISaevolgo%26password%3DQ3JleGVuZG8yMDI1%26cloud_id%3DCREXDEMODEV
        myIotumUrl = myIotumUrl.replaceAll("REDIRECT_URL_HERE", redirectUrl)
        console.log("iotum url", myIotumUrl);
        
        window.location.href = myIotumUrl;
    }

    const newMessagingHandler = () => {
        console.log("new messaging handler");
        setRedirect(<Redirect to = {newMessagingPath} />);
    }
    

    if(openVoicemail){
        setOpenVoicemail(false);
        console.log("here");
        setRedirect(<Redirect to = {voiceMailPath} />);
    }

    if(openViodeConf){
        setOpenVideoConf(false);
        setRedirect(<Redirect to = {crexendoHDPath} />);
    }

    if(openSettings){
        setOpenSettings(false);
        setRedirect(<Redirect to ={vmailSettingsPath} />);
    }

    if(openCallHistory){
        setOpenCallHistory(false);
        setRedirect(<Redirect to ={callHistoryPath} />);
    }

    if(openCallParking){
        setOpenCallParking(false);
        setRedirect(<Redirect to ={callParkingPath} />);
    }
    if(openTextable){
        localStorage.setItem("textableUrl", textableUrl);
        localStorage.setItem("textableProviderId", textableProviderId);
        localStorage.setItem("jwtToken", jwtToken);
        setOpenTextable(false);
        setRedirect(<Redirect to ={textablePath} />);
    }
    return(
        <Auxi>
            {redirect}
            <div className="bg-full auth-wrapper bg-black" 
                style={backgroundImage?
                {backgroundImage: `url(${process.env.REACT_APP_SIMPLE_API_URL + localStorage.getItem("custom_tab_background")} )`}:{backgroundColor: "black"}}>
                <div className="flex flex-wrap gap-4 justify-center" style={{top: "100px", position: "absolute", width: "100%", padding: "0 15px"}}>
                    <div className="flex-1 basis-[calc(50%-8px)] min-w-[calc(50%-8px)] max-w-[calc(50%-8px)]">
                        <div className="voice-mail-index setting-image">
                            <a href={cloudId ==="INTERACTIVETELVIP" ? "sip:*38?dialAction=autoCall" : "sip:*80?dialAction=autoCall"}>
                                <img src={icons === "white"? MoveCall : icons === "black"? MoveCallBlack: MoveCallBlue}/> 
                            </a>
                            <h5 style={{color: icons}}> Move <br/> Call</h5>
                        </div>
                    </div>
                    <div className="flex-1 basis-[calc(50%-8px)] min-w-[calc(50%-8px)] max-w-[calc(50%-8px)]">
                        <div className="voice-mail-index setting-image">
                            <img src={icons === "white"?VoiceMail:icons === "black"?VoiceMailBlack: VoiceMailBlue} onClick={ e => setOpenVoicemail(true)}/>
                            <h5 style={{color: icons}} > Visual <br/> VM</h5>
                        </div>
                    </div>
                    <div className="flex-1 basis-[calc(50%-8px)] min-w-[calc(50%-8px)] max-w-[calc(50%-8px)]">
                        <div className="voice-mail-index setting-image">
                            <img src={icons === "white"? CallParking:icons === "black"? CallParkingBlack: CallParkingBlue} onClick={ e => setOpenCallParking(true)}/>
                            <h5 style={{color: icons}} > Call <br/> Park</h5>
                        </div>
                    </div>
                    {
                        callHistory && (
                            <div className="flex-1 basis-[calc(50%-8px)] min-w-[calc(50%-8px)] max-w-[calc(50%-8px)]">
                                <div className="settings-index setting-image">
                                    <img src={icons === "white"? CallHistory:icons === "black"? CallHistoryBlack:CallHistoryBlue} onClick={e => setOpenCallHistory(true)}/>
                                    <h5 style={{color: icons}} >Call <br/> History</h5>
                                </div>
                            </div>
                        )
                    }
                    
                    <div className="flex-1 basis-[calc(50%-8px)] min-w-[calc(50%-8px)] max-w-[calc(50%-8px)]">
                        <div className="settings-index setting-image">
                            <img src={icons === "white"? Settings:icons === "black"? SettingsBlack:SettingsBlue} onClick={e => setOpenSettings(true)}/>
                            <h5 style={{color: icons}} >User <br/> Settings</h5>
                        </div>
                    </div>
                    {textable && (
                        <div className="flex-1 basis-[calc(50%-8px)] min-w-[calc(50%-8px)] max-w-[calc(50%-8px)]">
                            <div className="video-conf-index setting-image">
                                <img src={icons === "white"? Textable:icons === "black"? TextableBlack: TextableBlue} onClick={e => setOpenTextable(true)}/>
                                <h5 style={{color: icons}}>
                                    {textableName.split(" ").map((line,index)=>(
                                        <React.Fragment key={index}>
                                            {index !== 0 && <br/>}
                                            {line}
                                        </React.Fragment>
                                    ))}
                                </h5>
                            </div>
                        </div>
                    )}
                    {iotumUrl && (
                        <div className="flex-1 basis-[calc(50%-8px)] min-w-[calc(50%-8px)] max-w-[calc(50%-8px)]">
                            <div className="video-conf-index setting-image">
                                <img src={icons === "white"? IotumVideoConference:icons === "black"? IotumVideoConferenceBlack: IotumVideoConferenceBlue} onClick={ () => videoConferenceHandler(iotumUrl)}/>
                                <h5 style={{color: icons}}>
                                    {iotumName.split(" ").map((line,index)=>(
                                        <React.Fragment key={index}>
                                            {index !== 0 && <br/>}
                                            {line}
                                        </React.Fragment>
                                    ))}
                                </h5>
                            </div>
                        </div>
                    )}
                </div>
                
                {/* <div className="logo-index setting-image">
                    <img src={"https://www.crexendo.com/wp-content/uploads/2020/09/cx-logo-white-small.png"}/>
                </div> */}
                
                
            </div>
            <MfaAuthModal ref={mfaAuthRef} />

        </Auxi>
    );
}

export default Index;
